import angular from 'angular';
import uiRouter from 'angular-ui-router';
import versionComponent from './version.component';
import versionListComponent from './version-list.component';
import versionService from './version.service';

let versionModule = angular.module('appVersion', [
  uiRouter
])
.service('Version', versionService)
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/app-version');

  $stateProvider
    .state('app-version', {
      component: 'version'
    })
    .state('app-version.list', {
      url: '/app-version',
      component: 'versionList'
    })
})
.component('version', versionComponent)
.component('versionList', versionListComponent)
.name;

export default versionModule;



// WEBPACK FOOTER //
// ./client/app/components/version/version.js